import { useMutation, useQuery } from '@apollo/react-hooks';
import ConsultantContactCard from 'components/ConsultantContactCard';
import { FormScene } from 'constants/FormScene';
import { Button } from 'modules';
import DisplayDateTime from 'modules/DisplayDateTime';
import { LastMeetingDateQuery } from 'queries/MeetingDate/MeetingDate';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import {
  selectConsultantAccess,
  selectOnlineForm,
  selectOnlineFormContract,
  selectOnlineFormData,
} from 'stores/onlineForm/onlineForm';
import logoMax from 'assets/logoMax.png';
import { Container } from 'react-bootstrap';
import { SaveStartedContractOnlineFormMutation } from 'queries/ContractOnlineForms/ContractOnlineFormData';
import { bonatoCompany } from 'constants/company';

const OnlineFormStarter = () => {
  const wsContext = useContext(WebsocketContext);

  const form = useSelector(selectOnlineForm);
  const formData = useSelector(selectOnlineFormData);
  const contract = useSelector(selectOnlineFormContract);

  const isConsultantAccess = useSelector(selectConsultantAccess);

  const [saveStarter] = useMutation(SaveStartedContractOnlineFormMutation);

  const lastMeetingDateQuery = useQuery(LastMeetingDateQuery, {
    variables: {
      where: {
        contractId: contract?.id,
      },
    },
  });

  const meetingData = lastMeetingDateQuery?.data?.lastMeetingDate;

  const onSubmit = () => {
    saveStarter({
      variables: {
        id: form?.id,
      },
    });
    wsContext.send({
      action: WebsocketActions.STEP_CHANGE,
      value: FormScene.Agreement,
    });
  };

  return (
    <Container className="m-0">
      <div className="text-center mb-5">
        <div>
          <img
            src={logoMax}
            alt="Bonato"
            className="mt-5 mb-2"
            style={{ width: '80%', maxWidth: 400, margin: 'auto' }}
          />
        </div>
        <strong style={{ fontSize: '1.6em' }}>Pomáhame zadlženým ľuďom získať späť stratenú slobodu</strong>
      </div>

      <div className="mb-5" style={{ fontSize: '1.1em', lineHeight: '1.5em' }}>
        <p>Dobrý deň,{formData?.lastName ? ` pán/pani ${formData?.lastName},` : ``}</p>
        <div className="mb-3">
          <p>Zarezervovali sme Vám konzultáciu s naším Oddlžovacím poradcom:</p>
          {contract?.consultant2 && <ConsultantContactCard consultant={contract.consultant2} />}
          {meetingData && (
            <span>
              Bude Vás kontaktovať telefonicky{' '}
              <strong>
                <DisplayDateTime dateTime={meetingData?.time_from} />
              </strong>
            </span>
          )}
          .
        </div>
        <p>Držíme Vám palce, nech Vám to dobre dopadne!</p>
        <p>Tím {bonatoCompany.name}</p>
      </div>
      {isConsultantAccess && (
        <Button variant={'danger'} className="d-block mt-2" onClick={onSubmit}>
          Spustiť konzultáciu
        </Button>
      )}
    </Container>
  );
};

export default OnlineFormStarter;
